import React from 'react';
import Document from '../../../components/document';
import { DocumentInfo } from '../../../utilities/documentTypes';
import IcContinueRequestDocs from '../../../components/lists/workerDocumentsICContinue';
import WorkerDocumentsTab from '../../../components/lists/workerDocuments';

import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';

class DocumentsTab extends React.Component {
    renderICcontinue() {
        const { job } = this.props;
        const { contractor } = job;
        const { CONTRACTOR_INSURANCE } = DocumentInfo.types;

        return (
            <div className="col-md-10 col-xs-12">
                <IcContinueRequestDocs role={{ id: contractor.id, type: 'contractor' }} regime={job.regime} readOnly={true} />
                <div className="row">
                    <div className="col-xs-12 topOffset15">
                        <h4 className="topOffset15">
                            <FormattedMessage {...messages.otherDocuments} />
                        </h4>
                    </div>
                    <div className="col-xs-12">
                        <Document
                            id={`job-docs-${job.id}.${CONTRACTOR_INSURANCE.docType}`}
                            ownerRole={{ id: contractor.id, type: 'contractor' }}
                            view={{ showHeader: true }}
                            {...CONTRACTOR_INSURANCE}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderW2continue() {
        const { job } = this.props;

        return <WorkerDocumentsTab roleType={'admin'} job={job} />;
    }

    render() {
        const { job } = this.props;
        const { progress } = job;
        return <div className="row">{progress.branch === 'ic-continue-request' ? this.renderICcontinue() : this.renderW2continue()}</div>;
    }
}

export default DocumentsTab;



// WEBPACK FOOTER //
// ./src/pages/approval/tabs/documents.jsx